import {
    AnnounceInputs,
    PropertyInputs,
} from "../../../utils/AnnounceInterfaces";
import Api from "../../../https/Api";


interface ApiError {
    response?: {
      data?: {
        message?: string;
      };
    };
    message?: string;
  }

export class PropertyService {
    private api: Api;
    constructor() {
        this.api = new Api();
    }

    //get
    async getLocationTypes() {
        return this.api.get("locationTypes");
    }

    async getAnnounceByIdAdm(id: string) {
        return this.api.simpleGet("announces/getadm", id);
    }

    async getListAnnounces(filter: any, page: number = 1, limit: number = 10) {
        return this.api.simpleGetWithFilter(`announces`, filter);
    }

    async getListProperties(filter: any) {
        return this.api.simpleGetWithFilter(`properties`, filter);
    }

    async getAllEquipments() {
        return this.api.get("equipments");
    }

    async getAllPropertyTypes() {
        return this.api.get("propertiesTypes");
    }

    async getPropertyTypesBySearchType(searchTypeName: string) {
        return this.api.get(`propertytypes/searchtype/${searchTypeName}`);
    }

    async getAllEquipement() {
        return this.api.get("equipments");
    }
    async getAllCategory() {
        return this.api.get("categories");
    }

    async getPropertyById(id: string) {
        return this.api.simpleGet("properties/get", id);
    }

    async getListPropertiesPerPage(
        filter: any,
        page: number = 1,
        limit: number = 10
    ) {
        return this.api.simpleGetWithFilter(
            `properties/${page}/${limit}`,
            filter
        );
    }

    async getCommissionFeeByCountryAndCityId(
        countryName: string,
        cityName: string
    ) {
        return this.api.simpleGetWithTwoParams(
            "settings/commissions-fees-country-city",
            countryName,
            cityName
        );
    }

    async getHostFeeByCountryAndCityId(countryName: string, cityName: string) {
        return this.api.simpleGetWithTwoParams(
            "settings/hosts-fees-country-city",
            countryName,
            cityName
        );
    }

    async getSpecialFeeByPropertyType(propertyType: string) {
        return this.api.simpleGet(
            "settings/specials-fees/property-type",
            propertyType
        );
    }

      
      async updatePhotoOrder(propertyId: string, photoOrder: Array<{ photoId: string, order: number }>) {
          try {
              const response = await this.api.put(`properties/updatePhotoOrder/${propertyId}`, {
                  photoOrder
              });
              return response.data;
          } catch (error: unknown) {
              const err = error as ApiError;
              console.error('Error updating photo order:', err);
              throw new Error(
                  err.response?.data?.message || 
                  err.message || 
                  'Failed to update photo order'
              );
          }
      }
      
      async updateAdPhotoOrder(propertyId: string, photoOrder: Array<{ photoId: string, order: number }>) {
          try {
              const response = await this.api.put(`properties/updateAdPhotoOrder/${propertyId}`, {
                  photoOrder
              });
              return response.data;
          } catch (error: unknown) {
              const err = error as ApiError;
              console.error('Error updating ad photo order:', err);
              throw new Error(
                  err.response?.data?.message || 
                  err.message || 
                  'Failed to update ad photo order'
              );
          }
      }

    //post
    async saveAnnounce(announce: AnnounceInputs, idProperty: string) {
        const announceReq: AnnounceInputs = {
            ...announce,
            property: idProperty,
        };
        return this.api.post("announces/create", announceReq);
    }

    async savePropertyPhotosById(id: string, propertyPhoto: any) {
        return this.api.postFile("properties/uploadPhoto", id, propertyPhoto);
    }

    async saveAdPicturesById(id: string, adPicture: any) {
        return this.api.postFile("properties/uploadAdPicture", id, adPicture);
    }


    async savePropertyPhotosByIdFormData(id: string, photos: Array<{file: File}>) {
        //console.log(`Preparing to upload ${photos.length} photos for property ${id}`);
        const formData = new FormData();
        
        // Append each photo with the correct field name 'photo'
        photos.forEach((photo, index) => {
          if (photo.file) {
            //console.log(`Adding photo ${index}:`, photo.file.name, photo.file.type);
            formData.append('photo', photo.file, `photo_${index}_${Date.now()}`);
          }
        });
        
        try {
            const result = await this.api.postFormData(`properties/uploadPhoto/${id}`, formData);
            //console.log('Upload successful:', result);
            return result;
          } catch (error) {
            console.error('Photo upload failed:', error);
            throw error;
          }
      }
      
      async saveAdPicturesByIdFormData(id: string, adPhotos: Array<{file: File}>) {
        //console.log(`Preparing to upload Ad photo ${adPhotos.length} photos for property ${id}`);
        const formData = new FormData();
        
        // Append each ad photo with the correct field name 'adPicture'
        adPhotos.forEach((photo, index) => {
          if (photo.file) {
            //console.log(`Adding Ad photo ${index}:`, photo.file.name, photo.file.type);
            formData.append('adPicture', photo.file, `ad_${index}_${Date.now()}`);
          }
        });
        
        try {
            const result = await this.api.postFormData(`properties/uploadAdPicture/${id}`, formData);
            //console.log('Upload successful:', result);
            return result;
          } catch (error) {
            console.error('Photo upload failed:', error);
            throw error;
          }
      }

    async saveProperty(property: PropertyInputs) {
        return this.api.post("properties/create", property);
    }

    async updatePropertyById(property: PropertyInputs) {
        if (property._id)
            return this.api.postById(
                "properties/update",
                property._id,
                property
            );
    }

    //delete
    async deleteAnnounce(id: string) {
        return this.api.simpleDeleteById(`announces/delete`, id);
    }

    async deletesAnnounce(ids: string[]) {
        const param = {
            ids: ids,
        };
        return this.api.deleteMany("announces/deleteMany", param);
    }

    async getReviewsByAnnounceID(id: string) {
        return this.api.simpleGet("reviews/byAnnounce", id);
    }

    async deleteProperty(id: string) {
        return this.api.simpleDeleteById(`properties/delete`, id);
    }

    async deleteProperties(ids: string[]) {
        const param = {
            ids: ids,
        };
        return this.api.deleteMany("properties/deleteMany", param);
    }

    async deletePropertyPhotoByName(idProperty: string, photoName: string) {
        return this.api.deletePropertyPhoto(
            "properties/deletePhoto",
            idProperty,
            photoName
        );
    }

    async deletePropertyPhotoById(idProperty: string, idPhoto: string) {
        return this.api.deletePropertyPhoto(
            "properties/deletePhoto/ById",
            idProperty,
            idPhoto
        );
    }

    async deletePropertyAdPhotoByName(propertyId: string, photoName: string) {
        return this.api.deletePropertyPhoto(
            "properties/deleteAdPhoto",  // Changed from announces to properties
            propertyId,
            photoName
        );
    }
    
    async deletePropertyAdPhotoById(propertyId: string, photoId: string) {
        return this.api.deletePropertyPhoto(
            "properties/deleteAdPhoto/ById",  // Changed from announces to properties
            propertyId,
            photoId
        );
    }

    async refreshPropertyPhotos(idProperty: string) {
        return this.api.simpleGet("properties/getPhoto/ById", idProperty);
    }

    async getAllSearchTypes() {
        return this.api.get("searchTypes");
    }

    // put
    async allowOrBlockAnnoncePublishing(
        announceId: string,
        newAnounceState: string
    ) {
        const params = {
            announceId,
            state: newAnounceState,
        };

        return this.api.put("announces-validations/publishing", params);
    }

    // New method to update image order
    async updateImageOrder(propertyId: string, imageNames: string[]) {
        const params = {
            propertyId,
            imageNames,
        };
        return this.api.put("properties/update-image-order", params);
    }

    // New method to set cover image
    async setCoverImage(propertyId: string, imageName: string) {
        const params = {
            propertyId,
            imageName,
        };
        return this.api.put("properties/set-cover-image", params);
    }
}
